import { render, staticRenderFns } from "./ConfirmPhoneNumberNew.vue?vue&type=template&id=6df03e70&"
import script from "./ConfirmPhoneNumberNew.vue?vue&type=script&lang=js&"
export * from "./ConfirmPhoneNumberNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports